const monthLanguage = {
  "january" : "มกราคม",
  "february" : "กุมภาพันธ์",
  "march" : "มีนาคม",
  "april" : "เมษายน",
  "may" : "พฤษภาคม",
  "june" : "มิถุนายน",
  "july" : "กรกฎาคม",
  "august" : "สิงหาคม",
  "september" : "กันยายน",
  "october" : "ตุลาคม",
  "november" : "พฤศจิกายน",
  "december" : "ธันวาคม",
  "ytd" : "ตั้งแต่ต้นปี",
}

export const getThaiMonth = (month:string|undefined) => {
  if (!month) return "-"
  return monthLanguage[month?.toLowerCase() as keyof typeof monthLanguage];
}